import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TableResponsiveService {
  maxVisibleColumns$ = new BehaviorSubject<number>(Infinity);

  constructor(private breakpointObserver: BreakpointObserver) {
    this.breakpointObserver.observe([
      Breakpoints.Small,
      Breakpoints.Medium,
      Breakpoints.XSmall
    ]).subscribe(result => {
      if (result.breakpoints[Breakpoints.XSmall]) {
        this.maxVisibleColumns$.next(2);
      } else if (result.breakpoints[Breakpoints.Small]) {
        this.maxVisibleColumns$.next(3);
      } else if (result.breakpoints[Breakpoints.Medium]) {
        this.maxVisibleColumns$.next(4);
      } else {
        this.maxVisibleColumns$.next(Infinity);
      }
    });
  }

  /**
   * Calculate maximum columns based on data length and total columns
   */
  calculateMaxColumns(dataLength: number, totalColumns: number): number {
    if (dataLength === 0) return totalColumns;
    
    // Simple calculation - can be enhanced based on business logic
    const currentMax = this.maxVisibleColumns$.value;
    return Math.min(currentMax, totalColumns);
  }
}
